import { IEmployeeHourType } from './../../home.model';

export interface HomeState {
  calendarEvents: any[];
  employeeHours: IEmployeeHourType[];
  employeeStatus: any;
  loading: boolean;
  error: string | null;
}

export const initialState: HomeState = {
  calendarEvents: [],
  employeeHours: [],
  employeeStatus: null,
  loading: false,
  error: null,
};
